import LayoutCenter from "@/components/LayoutCenter";
import { Alert } from "@/components/ui/alert";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { PageProps } from "@/types/PageProps";
import { Head } from "@inertiajs/react";
import { AlertCircle, ArrowLeftIcon, CheckIcon } from "lucide-react";

type PageData = PageProps & {
  form_errors?: {
    email: string[];
    base: string;
  };
  email: string;
  token?: string;
  back_url?: string;
};

export default function Component({ form_errors, notice, errors, back_url }: PageData) {
  return (
    <LayoutCenter>
      <Head title="Confirm your email" />

      {form_errors?.base && (
        <Alert variant="destructive" className="mb-8 max-w-md">
          <div className="flex items-center gap-2">
            <AlertCircle className="h-4 w-4" />
            <p className="text-sm text-destructive">{form_errors.base}</p>
          </div>
        </Alert>
      )}
      {notice && (
        <Alert className="mb-8 max-w-md">
          <div className="flex items-center gap-2">
            <CheckIcon className="h-4 w-4" />
            <p className="text-sm">{notice}</p>
          </div>
        </Alert>
      )}
      {errors && (
        <Alert variant="destructive" className="mb-8 max-w-md">
          <div className="flex gap-2">
            <AlertCircle className="h-4 w-4" />
            <div className="flex flex-col gap-2">
              {errors.map((error) => (
                <p key={error} className="text-sm">
                  {error}
                </p>
              ))}
            </div>
          </div>
        </Alert>
      )}

      <div className="max-w-md space-y-4">
        <h1 className="text-lg font-bold">We need to confirm your email address</h1>
        <p>
          You should get an email shortly with instructions on how to login. If you don't see it,
          please check your spam folder.
        </p>

        <div className="pt-4">
          <a href={back_url || "/register"} className={cn(buttonVariants({ variant: "outline" }))}>
            <ArrowLeftIcon className="h-4 w-4" />
            Go back
          </a>
        </div>
      </div>
    </LayoutCenter>
  );
}
